import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * The swing arc, three frames.
 *
 * Authored pointing right and rotated for the other three facings. Rotation by
 * exact quarter turns is lossless on a pixel grid, so one set of art covers
 * every direction without the blur that arbitrary rotation would bring — and
 * without four sets to keep in step.
 *
 * Read as: the blade bites, the arc opens, the trail fades.
 */

const BITE: readonly string[] = [
  '................',
  '................',
  '................',
  '................',
  '.......w........',
  '......ww........',
  '......ww........',
  '......ww........',
  '......ww........',
  '......ww........',
  '.......w........',
  '................',
  '................',
  '................',
  '................',
  '................',
];

const OPEN: readonly string[] = [
  '................',
  '................',
  '......4.........',
  '.....4w4........',
  '....4ww44.......',
  '....4www4.......',
  '....4www44......',
  '....4www4.......',
  '....4ww44.......',
  '.....4w4........',
  '......4.........',
  '................',
  '................',
  '................',
  '................',
  '................',
];

const FADE: readonly string[] = [
  '................',
  '................',
  '.......4........',
  '......4.4.......',
  '.....4...4......',
  '.....4...4......',
  '.....4...44.....',
  '.....4...4......',
  '.....4...4......',
  '......4.4.......',
  '.......4........',
  '................',
  '................',
  '................',
  '................',
  '................',
];

export const SLASH_SPRITES = {
  'slash-0': { name: 'slash-0', rows: BITE, palette: PALETTE },
  'slash-1': { name: 'slash-1', rows: OPEN, palette: PALETTE },
  'slash-2': { name: 'slash-2', rows: FADE, palette: PALETTE },
} as const satisfies Record<string, SpriteDefinition>;

export type SlashSpriteKey = keyof typeof SLASH_SPRITES;

export const SLASH_FRAMES: readonly SlashSpriteKey[] = ['slash-0', 'slash-1', 'slash-2'];
